import { useEffect, useState } from "react";
import moment from "moment";
import { http } from "../../../core/Api";

// Diferença entre o relógio do servidor e o do navegador, buscada uma vez.
let offsetPromise = null;

const fetchOffset = () => {
  if (!offsetPromise) {
    const before = Date.now();
    offsetPromise = http("api/backend/v2/time", "GET")
      .then((response) => {
        const server = moment(response).valueOf();
        if (!response || response.error || Number.isNaN(server)) return 0;
        const after = Date.now();
        return server + (after - before) / 2 - after;
      })
      .catch(() => 0);
  }
  return offsetPromise;
};

// Fora de produção dá pra simular a data com ?agora=2026-11-06T10:00
// (fica salvo na aba até fechar; ?agora= vazio limpa).
const OVERRIDE_KEY = "sos-2026:agora";

const readOverride = () => {
  if (process.env.NODE_ENV === "production") return null;
  try {
    const param = new URLSearchParams(window.location.search).get("agora");
    if (param !== null) {
      if (param === "") sessionStorage.removeItem(OVERRIDE_KEY);
      else sessionStorage.setItem(OVERRIDE_KEY, String(new Date(param).getTime() - Date.now()));
    }
    const stored = sessionStorage.getItem(OVERRIDE_KEY);
    return stored === null ? null : Number(stored);
  } catch (e) {
    return null;
  }
};

// Hora "oficial" (servidor), atualizada a cada segundo.
export const useNow = () => {
  const [offset, setOffset] = useState(() => readOverride());
  const [now, setNow] = useState(() => Date.now() + (offset || 0));

  useEffect(() => {
    if (offset !== null) return;
    let alive = true;
    fetchOffset().then((o) => alive && setOffset(o));
    return () => {
      alive = false;
    };
  }, [offset]);

  useEffect(() => {
    const tick = () => setNow(Date.now() + (offset || 0));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [offset]);

  return now;
};

const pad = (n) => String(Math.floor(n)).padStart(2, "0");

// Partes do countdown: [{ l: "DIAS", v: "03" }, ...]
export const countdownParts = (targetIso, now, withSeconds = true) => {
  const s = Math.max(0, new Date(targetIso).getTime() - now) / 1000;
  const parts = [
    { l: "DIAS", v: pad(s / 86400) },
    { l: "HORAS", v: pad((s % 86400) / 3600) },
    { l: "MIN", v: pad((s % 3600) / 60) },
  ];
  if (withSeconds) parts.push({ l: "SEG", v: pad(s % 60) });
  return parts;
};
